import { useContext } from 'react';
import { ModalContext } from './Context.js';
export const useModal = () => useContext(ModalContext);
//# sourceMappingURL=useModal.js.map